<template>
  <Tab data-cy="trashed-lists">
    <template #title>Trashed Lists</template>
    <div>
      <Flash
        type="warning"
        class="dwp-text-xs dwp-mb-4"
      >Trashed lists will be permanently deleted after 30 days.</Flash>
      <div class="dwp-h-full dwp-divide-x dwp-divide-gray-100" v-loading="loading">
        <template v-if="Object.keys(trashed).length">
          <div v-for="item in trashed" :key="item.id" class="dwp-py-1">
            <List :list="item" @click.native.prevent="currentList = item; open = false;">
              <div class="dwp-flex dwp-items-center dwp--mx-1">
                <div class="dwp-tooltip-wrap dwp-p-1" @click="restore(item)" data-cy="restore-list">
                  <RefreshCcwIcon class="dwp-w-3 dwp-h-3 dwp-text-gray-500" />
                  <p class="dwp-tooltip">Un-Trash</p>
                </div>
                <div
                  class="dwp-tooltip-wrap dwp-p-1"
                  @click="forceDelete(item)"
                  data-cy="delete-list"
                >
                  <TrashIcon class="dwp-w-3 dwp-h-3 dwp-text-red-500" />
                  <p class="dwp-tooltip">Delete</p>
                </div>
              </div>
            </List>
            <div
              class="dwp-px-8 dwp--mt-1 dwp-text-xs dwp-cursor-pointer dwp-text-gray-500"
            >Will be deleted in {{ item.modified | difference }} days.</div>
          </div>
        </template>
        <div
          v-else
          data-cy="no-lists"
          class="dwp-text-xs dwp-justify-center dwp-px-8 dwp-py-2 dwp-flex dwp-text-gray-500 dwp-items-center dwp-truncate dwp-rounded-r-full dwp-mr-6 dwp-space-x-2"
        >No Lists</div>
      </div>
    </div>
  </Tab>
</template>

<script>
import Tab from "./templates/TabTemplate.vue";
import Flash from "@/components/ui/Flash.vue";
import List from "./List.vue";
import { RefreshCcwIcon, TrashIcon } from "vue-feather-icons";
import { get } from "vuex-pathify";
import { differenceInDays } from "date-fns";
import { Firebase } from "@/services/firebase";

export default {
  filters: {
    difference(val) {
      return (
        differenceInDays(
          val,
          Firebase.firestore.Timestamp.now().toMillis() - 2592000000
        ) + 1
      );
    },
  },
  components: {
    Tab,
    RefreshCcwIcon,
    Flash,
    TrashIcon,
    List,
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    lists: get("lists/items"),
    trashed() {
      return this.filterObject(this.lists || {}, (list) => {
        return list.status == "trashed";
      });
    },
  },

  // add archived to realtime updates
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("lists/bindTrashed", { clearModule: true });
    this.loading = false;
  },

  // return to normal
  async beforeDestroy() {
    await this.$store.dispatch("lists/bindLists", { clearModule: true });
  },

  methods: {
    restore(list) {
      this.$store.dispatch("lists/rePublish", list);
    },
    forceDelete(list) {
      let r = confirm("Permanently delete the list? There is no undo.");
      if (r) {
        this.$store.dispatch("lists/delete", list.id);
      }
    },
  },
};
</script>